import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import ListEmployers from "./List";
import { CareerCenterServicePath, EMPLOYERS } from "utils/constants";

import permissions from "app/permissions";
import ShowEmployeer from "./Show";

//permissions
export const resources = {
  isMenu: true,
  icon: <ManageAccountsIcon />,
  name: CareerCenterServicePath + EMPLOYERS,
  title: "Работодатели",
  list: <ListEmployers />,
  show: <ShowEmployeer />,
  permission: permissions.canPreviewEmployers,
  showPermission: permissions.canPreviewEmployers,
};
